import { defineComponent as I, createElementBlock as a, openBlock as s, Fragment as u, createVNode as f, createBlock as l, unref as t, withCtx as y, createCommentVNode as O, createElementVNode as n, resolveDynamicComponent as D, mergeProps as R, normalizeClass as d, renderSlot as h } from "vue";
import { ArrowUpLongIcon as A } from "./packages/icons/dist/esm/icons/arrow-up-long-icon.js";
import { ArrowDownLongIcon as P } from "./packages/icons/dist/esm/icons/arrow-down-long-icon.js";
import { ArrowsUpDownIcon as T } from "./packages/icons/dist/esm/icons/arrows-up-down-icon.js";
import { createReusableTemplate as $ } from "./node_modules/.pnpm/@vueuse_core@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/core/index.js";
import { useOUIAProps as M } from "./packages/core/dist/helpers/ouia.js";
import { classesFromBreakpointProps as W } from "./packages/core/dist/breakpoints.js";
import o from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table.js";
import c from "./node_modules/.pnpm/@patternfly_react-styles@6.2.2/node_modules/@patternfly/react-styles/css/components/Table/table-scrollable.js";
import { isDefined as k } from "./node_modules/.pnpm/@vueuse_shared@13.1.0_vue@3.5.13_typescript@5.8.3_/node_modules/@vueuse/shared/index.js";
const N = { key: 0 }, U = ["checked"], Q = /* @__PURE__ */ I({
  name: "PfTh",
  inheritAttrs: !1,
  __name: "Th",
  props: {
    component: { default: "th" },
    textCenter: { type: Boolean },
    modifier: {},
    width: {},
    dataLabel: {},
    selected: { type: Boolean, default: void 0 },
    scope: { default: "col" },
    sticky: { type: Boolean },
    rightBorder: { type: Boolean },
    leftBorder: { type: Boolean },
    stickyMinWidth: { default: "120px" },
    stickyLeftOffset: {},
    stickyRightOffset: {},
    subheader: { type: Boolean },
    sortable: { type: Boolean },
    sorted: { type: Boolean },
    direction: {},
    defaultDirection: {},
    favorites: { type: Boolean },
    ouiaId: {},
    ouiaSafe: { type: Boolean }
  },
  emits: ["sort", "select", "update:selected", "update:direction"],
  setup(b, { emit: B }) {
    const r = b, i = B, [g, p] = $(), C = M({ id: r.ouiaId, safe: r.ouiaSafe }), S = W(r, ["visibility"], o, { short: !0 });
    function w() {
      i("sort"), i("update:direction", r.direction === "desc" ? "asc" : "desc");
    }
    function v(e) {
      i("select", e, e.target.checked), i("update:selected", e.target.checked);
    }
    return (e, m) => (s(), a(u, null, [
      f(t(g), null, {
        default: y(() => [
          t(k)(e.selected) ? (s(), a("label", N, [
            n("input", {
              checked: e.selected,
              type: "checkbox",
              onChange: m[0] || (m[0] = (L) => v(L))
            }, null, 40, U)
          ])) : O("", !0)
        ]),
        _: 1
      }),
      (s(), l(D(e.component), R({ ...t(C), ...e.$attrs }, {
        role: "columnheader",
        class: [
          t(o).tableTh,
          e.width && [t(o).modifiers[`width_${e.width}`]],
          e.modifier && t(o).modifiers[e.modifier],
          t(S),
          {
            [t(o).tableSort]: e.sortable,
            [t(o).modifiers.selected]: e.sortable && e.sorted,
            [t(o).tableSubhead]: e.subheader,
            [t(o).modifiers.center]: e.textCenter,
            [t(o).tableCheck]: t(k)(e.selected),
            [t(c).tableStickyCell]: e.sticky,
            [t(c).modifiers.borderRight]: e.rightBorder,
            [t(c).modifiers.borderLeft]: e.leftBorder
          }
        ],
        style: e.sticky ? {
          "--pf-v6-c-table__sticky-cell--MinWidth": e.stickyMinWidth ? e.stickyMinWidth : void 0,
          "--pf-v6-c-table__sticky-cell--Left": e.stickyLeftOffset ? e.stickyLeftOffset : 0,
          "--pf-v6-c-table__sticky-cell--Right": e.stickyRightOffset ? e.stickyRightOffset : 0
        } : void 0,
        "data-label": e.dataLabel,
        "aria-sort": e.sortable ? e.sorted ? `${e.direction}ending` : "none" : void 0
      }), {
        default: y(() => [
          e.sortable ? (s(), a("button", {
            key: 0,
            class: d(t(o).tableButton),
            onClick: w
          }, [
            n("div", {
              class: d(t(o).tableButtonContent)
            }, [
              n("span", {
                class: d(t(o).tableText)
              }, [
                f(t(p)),
                h(e.$slots, "default")
              ], 2),
              n("span", {
                class: d(t(o).tableSortIndicator)
              }, [
                e.sortable && e.sorted ? e.direction == "asc" ? (s(), l(t(A), { key: 1 })) : (s(), l(t(P), { key: 2 })) : (s(), l(t(T), { key: 0 }))
              ], 2)
            ], 2)
          ], 2)) : (s(), a(u, { key: 1 }, [
            f(t(p)),
            h(e.$slots, "default")
          ], 64))
        ]),
        _: 3
      }, 16, ["class", "style", "data-label", "aria-sort"]))
    ], 64));
  }
});
export {
  Q as default
};
